// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface OperationscatalogFieldConstraints
 */
export interface OperationscatalogFieldConstraints {
  /**
   *
   * @type {number}
   * @memberof OperationscatalogFieldConstraints
   */
  maximum?: number;
  /**
   *
   * @type {number}
   * @memberof OperationscatalogFieldConstraints
   */
  minimum?: number;
  /**
   *
   * @type {boolean}
   * @memberof OperationscatalogFieldConstraints
   */
  multiple?: boolean;
  /**
   *
   * @type {string}
   * @memberof OperationscatalogFieldConstraints
   */
  pattern?: string;
}

/**
 * Check if a given object implements the OperationscatalogFieldConstraints interface.
 */
export function instanceOfOperationscatalogFieldConstraints(
  value: object,
): value is OperationscatalogFieldConstraints {
  return true;
}

export function OperationscatalogFieldConstraintsFromJSON(
  json: any,
): OperationscatalogFieldConstraints {
  return OperationscatalogFieldConstraintsFromJSONTyped(json, false);
}

export function OperationscatalogFieldConstraintsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationscatalogFieldConstraints {
  if (json == null) {
    return json;
  }
  return {
    maximum: json['maximum'] == null ? undefined : json['maximum'],
    minimum: json['minimum'] == null ? undefined : json['minimum'],
    multiple: json['multiple'] == null ? undefined : json['multiple'],
    pattern: json['pattern'] == null ? undefined : json['pattern'],
  };
}

export function OperationscatalogFieldConstraintsToJSON(
  json: any,
): OperationscatalogFieldConstraints {
  return OperationscatalogFieldConstraintsToJSONTyped(json, false);
}

export function OperationscatalogFieldConstraintsToJSONTyped(
  value?: OperationscatalogFieldConstraints | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    maximum: value['maximum'],
    minimum: value['minimum'],
    multiple: value['multiple'],
    pattern: value['pattern'],
  };
}
